import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UpgradePopup } from '../../../components/elements/UpgradeConfirmModal';
import useFooterMenu from '../../../hooks/useFooterMenu';
import useLanguage from '../../../hooks/useLanguage';
import { __ } from '../../../translations';
import useGamification from '../hooks/useGamification';
import useRewardActions from '../hooks/useRewardActions';
import { PaymentFailedPopup, RenewalDueNotificationPopup } from './elements';
import GamificationView from './presentation/GamificationView';

const Reward = () => {
    // Hooks
    const language = useLanguage();
    const { termsLink } = useFooterMenu();
    const { badges, earnQuests, balance, activeBadge, badgeLoading, questsLoading, balanceLoading } = useGamification();
    const {
        isBillingFailurePopupOpen,
        isUpgradeModalOpen,
        isRenewalDuePopupOpen,
        handleClickSubscriptionQuest,
        handleRewardCtaClick,
        isSubscriptionQuest,
        shouldShowMissionCompleted,
        shouldShowSubscriptionQuest,
        getRedeemCTA,
        getSubscriptionCtaText,
        getQuestDescription,
        isSubsRenewalFailed,
        upgradeHandler,
        paymentFailedHandler,
        RenewalDueNotificationHandler,
    } = useRewardActions();

    // Effects
    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <GamificationView
            badgeProps={{ activeBadge, badgeLoading, badges }}
            scoreCardProps={{ activeBadge, balance, badgeLoading, balanceLoading, termsLink, getRedeemCTA }}
            questProps={{
                quests: earnQuests,
                isLoading: questsLoading,
                shouldRenderQuest: (quest) => shouldShowSubscriptionQuest(quest),
                buildRewardProps: (quest) => {
                    const isSubscriptionCard = isSubscriptionQuest(quest);
                    const baseProps: any = {
                        type: 'preview',
                        heading: __(quest.title),
                        description: getQuestDescription(quest),
                        reward: quest.points,
                        cta: {
                            text: getSubscriptionCtaText(quest),
                            ...(isSubscriptionCard
                                ? {}
                                : {
                                      linkComponent: Link,
                                      href: `/${language}/${quest.redirect || ''}`,
                                      transformLinkProps: ({ href }: any) => ({ to: href }),
                                  }),
                        },
                        errorText:
                            isSubscriptionCard && isSubsRenewalFailed
                                ? __('earn_reward_subscription_suspended_error_text')
                                : '',
                        isCompleted: isSubscriptionCard && shouldShowMissionCompleted(quest),
                        ctaLinkOnClick: () => {
                            handleRewardCtaClick(quest);
                            if (isSubscriptionCard) {
                                handleClickSubscriptionQuest(quest);
                            }
                        },
                    };

                    return baseProps;
                },
            }}
        >
            {isUpgradeModalOpen && (
                <UpgradePopup
                    isOpen={isUpgradeModalOpen}
                    handleCloseModal={() => upgradeHandler(false)}
                    OnUpgradeClick={() => upgradeHandler(true)}
                />
            )}
            {isBillingFailurePopupOpen && (
                <PaymentFailedPopup
                    isOpen={isBillingFailurePopupOpen}
                    closePopup={() => paymentFailedHandler(false)}
                    handleUpdatePayment={() => paymentFailedHandler(true)}
                />
            )}
            {isRenewalDuePopupOpen && (
                <RenewalDueNotificationPopup
                    isOpen={isRenewalDuePopupOpen}
                    closePopup={RenewalDueNotificationHandler}
                />
            )}
        </GamificationView>
    );
};

export default Reward;
